export const rupeeFormatter = (value) => {
  if (value == null || isNaN(value)) return "0";

  // Split integer and decimal parts
  const [intPart, decimalPart] = String(value).split(".");

  // Apply Indian number system formatting to integer part
  let lastThree = intPart.slice(-3);
  let otherNumbers = intPart.slice(0, -3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  const formattedInt = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  // Keep up to 2 decimals if present
  return decimalPart ? `${formattedInt}.${decimalPart.slice(0, 2)}` : formattedInt;
};
